import { View } from 'react-native';
import Svg, { G, Path, Circle, Rect, Polygon } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

// Lucide 0.447.0 geometry, matching marketing (tasks uses 1.59.0 users-round-collaboration). See docs/lucide-license.txt.
const featureIcons = {
    people: <><Path d="M18 21a8 8 0 0 0-16 0" /><Circle cx="10" cy="8" r="5" /><Path d="M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3" /></>,
    events: <><Path d="M8 2v4M16 2v4" /><Rect width="18" height="18" x="3" y="4" rx="2" /><Path d="M3 10h18M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01M16 18h.01" /></>,
    groups: <><Rect x="16" y="16" width="6" height="6" rx="1" /><Rect x="2" y="16" width="6" height="6" rx="1" /><Rect x="9" y="2" width="6" height="6" rx="1" /><Path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3M12 12V8" /></>,
    paths: <><Rect width="8" height="8" x="3" y="3" rx="2" /><Path d="M7 11v4a2 2 0 0 0 2 2h4" /><Rect width="8" height="8" x="13" y="13" rx="2" /></>,
    followUp: <><Circle cx="10" cy="8" r="5" /><Path d="M2 21a8 8 0 0 1 13.292-6M22 19h-6m3-3-3 3 3 3" /></>,
    forms: <><Rect width="20" height="12" x="2" y="6" rx="2" /><Path d="M12 12h.01M17 12h.01M7 12h.01" /></>,
    tasks: <><Path d="M20.453 8.911a9 9 0 00-6.696-5.738" /><Path d="M21 22a4 4 0 00-8 0" /><Path d="M3 12a4 4 0 017.963-.543" /><Path d="M3.889 15.9a9 9 0 005.247 4.632" /><Circle cx="17" cy="15" r="3" /><Circle cx="7" cy="5" r="3" /></>,
    give: <><Path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" /><Path d="M12 5 9.04 7.96a2.17 2.17 0 0 0 0 3.08c.82.82 2.13.85 3 .07l2.07-1.9a2.82 2.82 0 0 1 3.79 0l2.96 2.66M18 15l-2-2M15 18l-2-2" /></>,
    files: <><Path d="M21 7h-3a2 2 0 0 1-2-2V2M21 6v6.5c0 .8-.7 1.5-1.5 1.5h-7c-.8 0-1.5-.7-1.5-1.5v-9c0-.8.7-1.5 1.5-1.5H17ZM7 8v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H15M3 12v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H11" /></>,
    training: <><Path d="M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0zM22 10v6M6 12.5V16a6 3 0 0 0 12 0v-3.5" /></>,
    giving: <><Path d="M3 22h18M6 18v-7M10 18v-7M14 18v-7M18 18v-7" /><Polygon points="12 2 20 7 4 7" /></>,
    connect: <Path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />,
    roles: <><Path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zM9 12l2 2 4-4" /></>,
    analytics: <Path d="M3 3v16a2 2 0 0 0 2 2h16M18 17V9M13 17V5M8 17v-3" />,
    dashboard: <><Rect width="7" height="9" x="3" y="3" rx="1" /><Rect width="7" height="5" x="14" y="3" rx="1" /><Rect width="7" height="9" x="14" y="12" rx="1" /><Rect width="7" height="5" x="3" y="16" rx="1" /></>,
    recent: <Path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8M3 3v5h5M12 7v5l4 2" />,
};

const colorKeys = { files: 'admin', roles: 'admin', dashboard: 'primary', recent: 'primary', give: 'giving', followUp: 'paths' };

const routeFeatures = {
    people: 'people', events: 'events', tasks: 'tasks', smallgroups: 'groups',
    paths: 'paths', automations: 'paths', 'follow-up': 'followUp', training: 'training', forms: 'forms', files: 'files', library: 'files',
    connect: 'connect', contributions: 'giving', give: 'give', roles: 'roles',
    permissions: 'roles', analytics: 'analytics',
};

// '/people/<id>?tab=<key>' deep links surface module content inside a profile —
// map those tabs to their module feature instead of the generic people icon.
// Follow Up rides the shared 'paths' module color — no new color is added.
const PEOPLE_TAB_FEATURES = { giving: 'giving', tasks: 'tasks', training: 'training', followup: 'followUp' };

export const getRouteFeature = (screen) => {
    const seg = screen?.split(/[/?]/)[1];
    if (seg === 'people') {
        const tab = new URLSearchParams(screen?.split('?')[1] || '').get('tab');
        if (PEOPLE_TAB_FEATURES[tab]) return PEOPLE_TAB_FEATURES[tab];
    }
    return routeFeatures[seg];
};
export const getFeatureColorKey = (feature) => colorKeys[feature] || feature;

export default function FeatureIcon({ feature, size = 32, iconSize = 18, testID, children, neutral = false, active = false }) {
    const { theme: { colors } } = useUnistyles();
    const colorKey = colorKeys[feature] || feature;
    const quiet = neutral && !active;
    const color = quiet ? colors.admin : colors[colorKey] || colors.primary;
    const background = quiet ? colors.adminContainer : colors[`${colorKey}Container`] || colors.primaryContainer;
    const geometry = featureIcons[feature] || featureIcons.dashboard;
    const inset = (size - iconSize) / 2;

    return (
        <View testID={testID} accessible={false} pointerEvents="none" style={{ position: 'relative', width: size, height: size, flexShrink: 0 }}>
            <Svg width={size} height={size} viewBox="0 0 100 100">
                <G transform="translate(2, 2) scale(0.96)">
                    <Polygon points="24,0 100,0 100,72 76,100 0,100 0,28" fill={background} stroke={color} strokeOpacity={0.3} strokeWidth={3} strokeLinejoin="round" />
                </G>
            </Svg>
            {children ? <View style={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, alignItems: 'center', justifyContent: 'center' }}>{children}</View> :
            <Svg width={iconSize} height={iconSize} viewBox="0 0 24 24" style={{ position: 'absolute', top: inset, left: inset }}>
                <G fill="none" stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                    {geometry}
                </G>
            </Svg>}
        </View>
    );
}
